import { WebClientResponse, WebClientErrorResponse } from '../requester/webClientResponse';
import { WebClientRequest } from '../requester/webClientRequest';
import { WebClientApiErrorResult, WebClientApiResponse, WebClientApiResult } from './WebClientApiResponse';
import { WebClientApiError } from './WebClientApiError';
import { WebClientRequester, WebClientRequesterWrapper } from '../requester/webClientRequester';
import { WebClientFetchRequester } from '../requester/WebClientFetchRequester';
import { SessionManager } from '../managers/SessionManager';

export class VizPortalWebClientRequester extends WebClientRequesterWrapper {

  public sessionManager: SessionManager;

  public constructor(
    requester: WebClientRequester = new WebClientFetchRequester(),
    sessionManager: SessionManager = new SessionManager(requester)
  ) {
    super(requester);
    this.sessionManager = sessionManager;
  }

  public send<TResponse>(webClientRequest: WebClientRequest<Object|void, TResponse>): PromiseLike<WebClientResponse<TResponse>> {
    return this.sessionManager.ensureSessionInfo().then(() => super.send(webClientRequest));
  }

  public static isErrorResult<T>(result: T | WebClientApiErrorResult): result is WebClientApiErrorResult {
    return !!(<WebClientApiErrorResult> result).errors;
  }

  public static isErrorResponse<T>(response: WebClientResponse<T>): response is WebClientErrorResponse {
    return !!(<WebClientErrorResponse> response).error;
  }

  public static getErrors(res: WebClientApiResponse<WebClientApiResult>): WebClientApiError[] {
    return VizPortalWebClientRequester.isErrorResult(res.result) ? res.result.errors : [];
  }

  public static getSuccessResult<TResult>(response: WebClientResponse<WebClientApiResponse<TResult>>): PromiseLike<TResult> {
    if (VizPortalWebClientRequester.isErrorResponse(response)) {
      return Promise.reject(response);
    }

    let result = response.response.result;
    if (VizPortalWebClientRequester.isErrorResult(result)) {
      return Promise.reject(response);
    }

    return Promise.resolve(result);
  }
}
